export const topOfPageItems = [
  {
    title: 'Total premises passed',
    value: 0
  },
  {
    title: 'Total residential customers',
    value: 0
  },
  {
    title: 'Current month new connections',
    value: 0
  },
  {
    title: 'Total monthly recurring revenue',
    value: 0
  },
  {
    title: 'Total on-net buildings',
    value: 0
  },
  {
    title: 'Total commercial customers',
    value: 0
  },
  {
    title: 'Current month MRR increase',
    value: 0
  },
  {
    title: 'Churn current month',
    value: 0
  }
]
